import $ from 'jquery';
import scrollama from 'scrollama';
import { throttle } from 'throttle-debounce';

export const wistiaHeroBlock = {
	setupWistia: () => {
		let wistiaHeros = document.querySelectorAll('.js-wistia-hero');

		if (!wistiaHeros.length) {
			return;
		}

		wistiaHeros.forEach((wistiaHero) => {
			let wistiaId = wistiaHero.getAttribute('data-wistia-id');

			if(wistiaId) {
				window._wq = window._wq || [];
				_wq.push({
					id: wistiaId, // Replace with your actual video ID
					onReady: function(video) {
						let embedArea = video.container;
						let customButton = document.createElement("div");
						customButton.id = "customPlayButton";

						embedArea.appendChild(customButton);
						setTimeout(() => {
							customButton.classList.add('visible');
						}, 25);


						// Bind custom behavior when the video plays
						video.bind("play", function() {
							customButton.classList.remove("visible");
						});

						// Bind custom behavior when the video plays
						video.bind("pause", function() {
							customButton.classList.add("visible");
						});

						video.bind("end", function() {
							// Reset video to start
							video.pause();
							video.time(0);

							customButton.classList.add("visible");
						});
					}
				});
			}
		});
	},

	init: () => {
		wistiaHeroBlock.setupWistia();
	},
};

if (document.readyState === 'loading') {
	// Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', wistiaHeroBlock.init);
} else {
	// `DOMContentLoaded` has already fired
	wistiaHeroBlock.init();
}
